import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import ru_RU from '@react-pdf-viewer/locales/lib/ru_RU.json';

export function PdfUrlViewer({ pdfUrl, className }: { pdfUrl: string; className?: string }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.js">
      <div className={`w-full ${className}`}>
        <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} localization={ru_RU} />
      </div>
    </Worker>
  );
}
